module.exports = __webpack_public_path__ + "static/scale-model-of-circus-circus-reno-in-reno-nevada-b51db316b8cf3ea79eb57f282f9c4249.png";